export default __webpack_public_path__ + "assets/images/telegram-72ca51431a2978ca7e59ebd42a0aa8e0.svg";